import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router'
import { Box, Heading, Text, Button, Input, Stack } from '@/components/lib'
import api from '../../api'
import utils from '../../utils/utils.js'

import useTitle from '../../hooks/useTitle'
import EntryContainer from '../includes/EntryContainer'

export default function ForgottenPassword () {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  useTitle('Forgotten Password')

  function sendEmail () {
    setLoading(true)
    api.accounts.sendPasswordResetEmail(email, () => {
      setLoading(false)
      utils.toast('success', 'OK, done', 'If your account exists, a password email has been sent')
      navigate('/')
    }, (err) => {
      setLoading(false)
      utils.toast('error', 'Unable to reset your password', err.message)
    })
  }

  return (
    <EntryContainer>
      <Heading size='lg' mb={5}>Password reset</Heading>
      <Box p={4} bg='bg.subtle' rounded='md'>
        <Stack gap={5} direction='row' justifyContent='space-between' alignItems='center'>
          <Box>
            <Heading size='sm' mb={2}>Remembered your password?</Heading>
            <Text fontSize='sm'>If you've remembered your password, you can use it to login.</Text>
          </Box>
          <Button colorPalette='primary' variant='outline' as={Link} to='/'>Login</Button>
        </Stack>
      </Box>

      <Heading size='sm' mb={4} mt={5}>Type your email address below, and we'll send you a password-reset email.</Heading>
      <Input size='lg' type='email' value={email} onChange={e => setEmail(e.target.value)} placeholder='mary@example.com' autoFocus />
      <Button mt={4} colorPalette='primary' onClick={sendEmail} isLoading={loading}>Send Email</Button>
    </EntryContainer>
  )
}
